import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_CUSTOMERSBYCOMPANYID } from "../../../utils/constants";
import { CustomerInterface } from "../../../models/TicketModule/Customer";
import customerService from "../../../services/ticketService/customerService";

const useCustomerByCompId = (
  page: number,
  pageSize: number,
  companyId: string | undefined
) =>
  useQuery<CustomerInterface[], Error>({
    queryKey: [
      CACHE_KEY_CUSTOMERSBYCOMPANYID,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
      companyId,
    ],
    queryFn: () => customerService.GetByCompId(page, pageSize, companyId),
  });
export default useCustomerByCompId;
